<!-- <h2>Last Updated Users</h2>
<div class="users-menu">
  <a *ngFor="let user of users"
    routerLink="/detail/{{user.user_id}}"
  >
    {{user.first_name}}
  </a>
</div> -->
<app-user-form></app-user-form>